var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'message', _vm.shit$("")]},[_c('i',{class:['el-icon-loading']}),_vm._v(" dasdad\n")])}
var staticRenderFns = []

export { render, staticRenderFns }